import { Component, computed, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { PAGE_ROUTE } from '@app/constants/page-route';
import { AccessRoleType } from '@app/modules/user-management/enums/access-role-type.enum';
import { environment } from '@env/environment';
import { ContentHeaderComponent } from '../../components/content-header/content-header.component';
import { NavigationComponent } from '../../components/navigation/navigation.component';
import { AppStore } from '@app/stores/app/app.store';

@Component({
    selector: 'app-shell',
    imports: [RouterModule, NavigationComponent, ContentHeaderComponent],
    templateUrl: './user-management-shell.component.html',
    styleUrls: ['./user-management-shell.component.scss'],
})
export class UserManagementShellComponent {
    private appStore = inject(AppStore);
    translate = this.appStore.i18n;
    navs = computed(() => {
        const { TITLE__SuperAdmin, TITLE__Account_Manager, TITLE__Client } =
            this.translate();
        return [
            {
                navId: 1,
                displayText: TITLE__SuperAdmin,
                description: '',
                targetUrl: `/${PAGE_ROUTE.Main}/${PAGE_ROUTE.UserManagement}/${PAGE_ROUTE.SuperAdmin}`,
                icon: '',
                sortOrder: 1,
                roles: [
                    {
                        role: environment.accessRoles[AccessRoleType.SA],
                        scRole: '',
                        serviceLines: [],
                    },
                ],
            },
            {
                navId: 2,
                displayText: TITLE__Account_Manager,
                description: '',
                targetUrl: `/${PAGE_ROUTE.Main}/${PAGE_ROUTE.UserManagement}/${PAGE_ROUTE.AccountManagement}`,
                icon: '',
                sortOrder: 2,
                roles: [
                    {
                        role: environment.accessRoles[AccessRoleType.SA],
                        scRole: '',
                        serviceLines: [],
                    },
                ],
            },
            {
                navId: 3,
                displayText: TITLE__Client,
                description: '',
                targetUrl: `/${PAGE_ROUTE.Main}/${PAGE_ROUTE.UserManagement}/${PAGE_ROUTE.Client}`,
                icon: '',
                sortOrder: 3,
                roles: [
                    {
                        role: environment.accessRoles[AccessRoleType.AccountManager],
                        scRole: '',
                        serviceLines: [],
                    },
                ],
            },
        ];
    });
}
